module.exports = [{
      plugin: require('/etc/jenkins-agent/workspace/IC_Websites_inPower_Build_master/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
